import { TranslatePipe } from "src/app/app.module";

interface FiltersMetadataInterface {
  checkboxes: CheckboxesMetadataInterface;
  sliders: SliderOptionsMetadataInterface;
}

interface CheckboxesMetadataInterface {
  stops: string;
}

interface SliderOptionsMetadataInterface {
  outbound: string;
  inbound: string;
  departure: string;
  arrival: string;
}

export const FiltersOptionsMetadata: FiltersMetadataInterface = {
  checkboxes: {
    stops: TranslatePipe.transform('flightsPage.checkboxes.stops'),
  },
  sliders: {
    outbound: TranslatePipe.transform('flightsPage.sliders.outbound'),
    inbound: TranslatePipe.transform('flightsPage.sliders.inbound'),
    departure: TranslatePipe.transform('flightsPage.sliders.departure'),
    arrival: TranslatePipe.transform('flightsPage.sliders.arrival'),
  }
}
